import CloseIcon from "@mui/icons-material/Close";
import { IconButton, styled } from "@mui/material";
import { SnackbarKey, SnackbarProvider as NotistackProvider } from "notistack";
import React, { createRef, useCallback } from "react";

import { ariaLabel } from "src/constants";

const StyledContainer = styled("div")(({ theme }) => ({
  "& .SnackbarItem-variantSuccess": {
    backgroundColor: `${theme.palette.green.main} !important`,
  },
  "& .SnackbarItem-variantError": {
    backgroundColor: `${theme.palette.red.main} !important`,
  },
}));

export const SnackbarProvider = ({ children }: { children: React.ReactNode }) => {
  const notistackRef = createRef<NotistackProvider>();
  const onClickDismiss = useCallback(
    (key: SnackbarKey) => () => {
      if (!notistackRef.current) {
        return;
      }

      notistackRef.current.closeSnackbar(key);
    },
    []
  );

  const action = useCallback((key: SnackbarKey) => {
    return (
      <IconButton aria-label={ariaLabel.close} onClick={onClickDismiss(key)}>
        <CloseIcon />
      </IconButton>
    );
  }, []);

  return (
    <StyledContainer>
      <NotistackProvider
        ref={notistackRef}
        preventDuplicate
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        action={action}
      >
        {children}
      </NotistackProvider>
    </StyledContainer>
  );
};
